import { render, staticRenderFns } from "./hearXAccount.vue?vue&type=template&id=5b5b0a46&scoped=true&"
import script from "./hearXAccount.vue?vue&type=script&lang=ts&"
export * from "./hearXAccount.vue?vue&type=script&lang=ts&"
import style0 from "./hearXAccount.vue?vue&type=style&index=0&id=5b5b0a46&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b0a46",
  null
  
)

export default component.exports